import * as React from 'react';

type AgreementMarkProps = React.SVGProps<SVGSVGElement> & {
    borderColor?: string;
    backgroundColor?: string;
};

export const AgreementMark: React.FC<AgreementMarkProps> = React.memo(({
    borderColor,
    backgroundColor,
    height = 22,
    width = 22,
    ...props
}) => {
    const style = {
        ...(props.style || {}),
        '--border-color': borderColor,
        '--bg-fill': backgroundColor
    };
    return (
        <svg width={width} height={height} viewBox='0 0 22 22' xmlns='http://www.w3.org/2000/svg' {...props} style={style}>
            <circle cx='11' cy='11' r='10.5' fill='var(--bg-fill, none)' stroke='var(--border-color, currentColor)' strokeWidth='1'></circle>
            <text x='11' y='16' textAnchor='middle' fontFamily='Inter, Arial, Helvetica, sans-serif' fontSize='15' fontWeight='600' fill='currentColor'>A</text>
        </svg>
    );
});
